import { render } from "./SmallButton.vue?vue&type=template&id=c5c93682&scoped=true"
import script from "./SmallButton.vue?vue&type=script&lang=js"
export * from "./SmallButton.vue?vue&type=script&lang=js"

import "./SmallButton.vue?vue&type=style&index=0&id=c5c93682&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5c93682"]])

export default __exports__